import React from "react";
import { useNavigate } from "react-router-dom";
import AlertModal from "./AlertModal";
import TranslatableText from "../translations/TranslatableText";
import { ButtonProps } from "../button/Button";

interface ImportConflictModalProps {
    isOpen: boolean;
    projectId: number;
    projectName: string;
    onClose: () => void;
    onImportAsCopy: () => void;
}

const ImportConflictModal: React.FC<ImportConflictModalProps> = ({
    isOpen,
    projectId,
    projectName,
    onClose,
    onImportAsCopy,
}) => {
    const navigate = useNavigate();

    const handleOpenExisting = () => {
        navigate(`/project/${projectId}/activities`);
        onClose();
    };

    const openExistingButton: ButtonProps = {
        onClick: handleOpenExisting,
        children: <TranslatableText translationKey="project.open_existing" />,
        type: "button",
    };

    const importAsCopyButton: ButtonProps = {
        onClick: onImportAsCopy,
        children: <TranslatableText translationKey="project.import_as_copy" />,
        type: "button",
    };

    const cancelButton: ButtonProps = {
        onClick: onClose,
        children: <TranslatableText translationKey="main.cancel" />,
        type: "button",
    };

    return (
        <AlertModal
            modalOpen={isOpen}
            handleCancel={onClose}
            headerText="project.import_conflict_title"
            buttons={[cancelButton, importAsCopyButton, openExistingButton]}
            size="md"
        >
            <p className="w-100 h-100 p-3 d-flex align-items-center justify-content-center text-center">
                <TranslatableText
                    translationKey="project.import_conflict_message"
                    translationParams={{ projectName }}
                />
            </p>
        </AlertModal>
    );
};

export default ImportConflictModal;
